// Do not supply a timeZone: Intl uses the viewer's browser/device setting.
// Broadcast timezone conversion belongs in launchShows, not display formatting.
export function formatLocalAirtime(target: Date, locale?: string) {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric',
    minute: '2-digit', timeZoneName: 'short',
  }).format(target)
}

export function remainingParts(target: Date, now: Date) {
  const remaining = Math.max(0, target.getTime() - now.getTime())
  return {
    days: Math.floor(remaining / 86_400_000),
    hours: Math.floor((remaining / 3_600_000) % 24),
    minutes: Math.floor((remaining / 60_000) % 60),
    seconds: Math.floor((remaining / 1_000) % 60),
  }
}
